module.exports = __webpack_public_path__ + "img/ayun-quantity-based-screens.e95f677b.png";